import { OrdersTable } from "@/features/orders/orders-table";

const OrdersScreen = () => {
  return (
    <div className="p-4">
      <OrdersTable />
    </div>
  );
};

export default OrdersScreen;
